module.exports = __webpack_public_path__ + "img/gold.8ef67e71.png";